import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { path, prop } from 'ramda'
import moment from 'moment'
import * as stateNames from '../../constants/states'
import { getDaysDifference } from '../../utils/date'
import { TProfile } from '../../types'

const Card = styled.div`
  border: 1px solid #C0C0C0;
  padding: 33px;
`
const SubscriptionBlock = props => {
  const profile = useSelector(prop(stateNames.PROFILE))
  const data = path<TProfile>(['data', 'data'], profile)
  const BlockedDate = prop('blockedDate', data)

  const blockDays = moment(BlockedDate).diff(moment(), 'days')
  return (
    <Card className={`text-xl ${blockDays <= 5 ? 'bg-red-600' : 'bg-white'}`}>
      <p className={`font-medium ${blockDays <= 5 ? 'text-white' : 'text-black'}`}>До истичение срока</p>
      <p className={blockDays <= 5 ? 'text-white' : 'text-400'}>{blockDays} дн.</p>
    </Card>
  )
}

export default SubscriptionBlock
